import React from "react";

import { Navigate, createFileRoute } from "@tanstack/react-router";

import { PatientRedirectPage } from "@/pages/patient-redirect/PatientRedirectPage.tsx";
import { Queries } from "@/queries/Queries.ts";

const PatientRouteGuard: React.FC = () => {
  const me = Queries.user.useMe({});
  switch (me.userType) {
    case "patient":
      return <PatientRedirectPage />;
    default:
      return <Navigate to="/" />;
  }
};

export const Route = createFileRoute("/patient")({
  component: PatientRouteGuard,
});
